import React from "react";
import { Card } from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
const NewsCard = ({ data, small, id }) => {
    const { t } = useTranslation();
    return (
        <div className="card-container cursor-pointer rounded-2xl">
            {small ? (
                <>
                    <Card
                        className="shadow-xl rounded-2xl"
                        style={{ height: "450px", width: "300px" }}
                        cover={
                            <img
                                style={{ height: "150px", objectFit: "cover" }}
                                alt="example"
                                src={data?.special_image}
                                className="new-card_img cursor-pointer "
                            />
                        }
                    >
                        <div className="cursor-pointer overflow-y-auto m-0 p-0">
                            <h1 className=" cursor-pointer text-purple  font-medium break-words line-clamp-1  ">
                                {data?.special_content}
                            </h1>
                            <p className="pt-4 cursor-pointer text-lg font-medium  line-clamp-3 break-words">
                            {data.content || '....'}
                            </p>
                            <br />
                            <Link to={`/news/${id}`}>
                                <p className=" absolute bottom-[100px] text-purple text-xl font-semibold hover:text-lightGray">
                                    {t("More")}
                                </p>
                            </Link>
                        </div>
                    </Card>
                </>
            ) : (
                <Card
                    className="shadow-xl"
                    style={{ height: "550px", width: "350px" }}
                    cover={
                        <img
                            style={{ height: "350px", objectFit: "cover" }}
                            alt="example"
                            src={data?.special_image}
                            className="new-card_img cursor-pointer "
                        />
                    }
                >
                    <div className="overflow-y-auto cursor-pointer break-words">
                        <h1 className=" cursor-pointer text-purple my-2 font-medium  line-clamp-1  break-words">
                            {data?.special_content}
                        </h1>
                        <p className=" cursor-pointer text-lg font-medium break-words line-clamp-3  ">
                            {data.content || '....'}
                        </p>
                        <p className="text-lightGray my-3 font-medium cursor-pointer line-clamp-3  ">
                        <Link className="bottom-[40px] absolute" to={`/news/${id}`}>

                            {t("More")}
                            </Link>
                        </p>
                    </div>
                </Card>
            )}
        </div>
    );
};
export default NewsCard;
